import {gql} from '@apollo/client';

export const GET_ALL_QUICK_ACTIONS_CATEGORIES = gql`
  query GetAllQuickActionCategories($activeOnly: Boolean) {
    getAllQuickActionCategories(activeOnly: $activeOnly) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickActionCategories {
        data {
          id
          name
          language
          isActive
          position
          createdAt
        }
      }
    }
  }
`;

export const GET_ALL_QUICK_ACTIONS = gql`
  query GetAllQuickActions($filter: QuickActionFilterInput) {
    getAllQuickActions(filter: $filter) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickActions {
        data {
          createdAt
          id
          name
          key
          icon
          category {
            id
            name
          }
          newUntil
          position
          isDefault
          language
          isActive
          translations {
            language
            name
          }
          updatedAt
        }
      }
    }
  }
`;

export const CREATE_QUICK_ACTION_CATEGORY = gql`
  mutation CreateQuickActionCategory($input: QuickActionCategoryInput!) {
    createQuickActionCategory(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickActionCategory {
        message
      }
    }
  }
`;

export const UPDATE_QUICK_ACTION_CATEGORY = gql`
  mutation UpdateQuickActionCategory(
    $categoryId: ID!
    $input: QuickActionCategoryInput!
  ) {
    updateQuickActionCategory(categoryId: $categoryId, input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickActionCategory {
        message
      }
    }
  }
`;

export const GET_QUICK_ACTION_CATEGORY_BY_ID = gql`
  query GetQuickActionCategoryById($categoryId: ID!) {
    getQuickActionCategoryById(categoryId: $categoryId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickActionCategory {
        data {
          id
          name
          description
          position
          isActive
          language
          translations {
            language
            name
            description
          }
          createdAt
          updatedAt
          quickActions {
            id
            name
            key
            icon
            position
            isActive
            isDefault
            language
            newUntil
            translations {
              name
              language
            }
          }
        }
      }
    }
  }
`;

export const REORDER_QUICK_ACTIONS = gql`
  mutation ReorderQuickActions($positions: [ReorderItemInput!]!) {
    reorderQuickActions(positions: $positions) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const DELETE_QUICK_ACTION_CATEGORY = gql`
  mutation DeleteQuickActionCategory($categoryId: ID!) {
    deleteQuickActionCategory(categoryId: $categoryId) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const REORDER_QUICK_ACTION_CATEGORIES = gql`
  mutation ReorderQuickActionCategories($positions: [ReorderItemInput!]!) {
    reorderQuickActionCategories(positions: $positions) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const CREATE_QUICK_ACTION = gql`
  mutation CreateQuickAction($input: QuickActionInput!) {
    createQuickAction(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickAction {
        message
      }
    }
  }
`;

export const UPDATE_QUICK_ACTION = gql`
  mutation UpdateQuickAction($quickActionId: ID!, $input: QuickActionInput!) {
    updateQuickAction(quickActionId: $quickActionId, input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickAction {
        message
      }
    }
  }
`;

export const GET_QUICK_ACTION_BY_ID = gql`
  query GetQuickActionById($quickActionId: ID!) {
    getQuickActionById(quickActionId: $quickActionId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickAction {
        message
        data {
          id
          name
          key
          icon
          category {
            id
            name
          }
          newUntil
          position
          language
          isActive
          isDefault
          translations {
            language
            name
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const DELETE_QUICK_ACTION = gql`
  mutation DeleteQuickAction($quickActionId: ID!) {
    deleteQuickAction(quickActionId: $quickActionId) {
      ... on Error {
        message
        statusCode
      }
      ... on Response {
        message
      }
    }
  }
`;

export const REMOVE_QUICK_ACTION_FROM_CATEGORY = gql`
  mutation RemoveQuickActionFromCategory($quickActionId: ID!) {
    removeQuickActionFromCategory(quickActionId: $quickActionId) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickAction {
        message
      }
    }
  }
`;

export const ADD_QUICK_ACTION_TO_CATEGORY = gql`
  mutation AddQuickActionToCategory($quickActionId: ID!, $categoryId: ID!) {
    addQuickActionToCategory(
      quickActionId: $quickActionId
      categoryId: $categoryId
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithQuickAction {
        message
      }
    }
  }
`;
